import { render, staticRenderFns } from "./PenaltyAssessmentSearch.vue?vue&type=template&id=21b576aa"
import script from "./PenaltyAssessmentSearch.vue?vue&type=script&lang=js"
export * from "./PenaltyAssessmentSearch.vue?vue&type=script&lang=js"
import style0 from "./PenaltyAssessmentSearch.vue?vue&type=style&index=0&id=21b576aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports